export default class ClubAccessSettings {
    autoLogoutTime;
    membersEditOwnData;
    membersCanViewInvoices;
    sendBirthdayGreetings;
    defaultPaymentInterval;
    memberSinceDateStrategy;
    onlineMembershipTerminationEnabled;
    physicalAccessStateResetHour;
    physicalAccessFilterFlagResets = [];
    hasPhysicalAccessModule;
    invoiceNotificationTiming;
    invoiceNotificationDays;

    static fromData(data) {
        if (!data) {
            return;
        }

        const settings = new ClubAccessSettings();
        settings.autoLogoutTime = data.autoLogoutTime;
        settings.membersEditOwnData = data.membersEditOwnData;
        settings.membersCanViewInvoices = data.membersCanViewInvoices;
        settings.sendBirthdayGreetings = data.sendBirthdayGreetings;
        settings.defaultPaymentInterval = data.defaultPaymentInterval;
        settings.memberSinceDateStrategy = data.memberSinceDateStrategy;
        settings.onlineMembershipTerminationEnabled = data.onlineMembershipTerminationEnabled;
        settings.physicalAccessStateResetHour = data.physicalAccessStateResetHour;
        settings.physicalAccessFilterFlagResets = data.physicalAccessFilterFlagResets;
        settings.hasPhysicalAccessModule = data.hasPhysicalAccessModule;
        settings.invoiceNotificationTiming = data.invoiceNotificationTiming;
        settings.invoiceNotificationDays = data.invoiceNotificationDays;

        return settings;
    }

    serialize() {
        return {
            autoLogoutTime: Number.parseInt(this.autoLogoutTime),
            membersEditOwnData: this.membersEditOwnData,
            membersCanViewInvoices: this.membersCanViewInvoices,
            sendBirthdayGreetings: this.sendBirthdayGreetings,
            defaultPaymentInterval: this.defaultPaymentInterval,
            memberSinceDateStrategy: this.memberSinceDateStrategy,
            onlineMembershipTerminationEnabled: this.onlineMembershipTerminationEnabled,
            physicalAccessStateResetHour: this.physicalAccessStateResetHour !== null ? Number.parseInt(this.physicalAccessStateResetHour) : null,
            physicalAccessFilterFlagResets: this.physicalAccessFilterFlagResets
                .filter((reset) => reset.filterFlagId !== null)
                .map((reset) => ({ filterFlagId: reset.filterFlagId, hour: Number.parseInt(reset.hour) })),
            invoiceNotificationTiming: this.invoiceNotificationTiming,
            invoiceNotificationDays: this.invoiceNotificationDays !== null ? Number.parseInt(this.invoiceNotificationDays) : null,
        };
    }
}
